import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  
  
  
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();

    
    
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
/*
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': "xg3gnhcIgrHHL96M-v4pww",
      'token-type': "Bearer",
      'client':"dEW6u0nGFx8tu4UvoZ0wqw",
      'expiry':1728919988,
      'uid':"jjvasquezcabos@gmail.com",
    });*/
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
